import { VirtualMarketerPlan, StripePrice } from './types'

export const additionalSeatPrice = (plan: VirtualMarketerPlan, intervalCount: number) => {
  const additionalSeatPrice = plan.prices.find(
    (price: StripePrice) =>
      price.metadata.additional_key === 'seat' && price.recurring.interval_count === intervalCount,
  )

  if (!additionalSeatPrice) return 0

  return additionalSeatPrice.unit_amount / 100 / intervalCount
}
